/* eslint-disable no-unused-vars */
import BtnGroup from './containers/btn_group/BtnGroup';
import RuleTabel from './containers/rule_table/TablePage';
import OutputTabel from './containers/output_tabel/TablePage';
import { useState } from 'react';
import './index.less';
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'dva';
import { Divider, Form, message } from 'antd';
import { history } from 'umi';
import ModalML from '@/components/modal_ml/ModalML';
import AddRule from './containers/add_rule/AddRule';
import Loading from '@/components/Loading';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_rule_ml/ModalConfirmRuleML';
import {
  handleFormData,
  handleMultipleFormData,
  hasUndefInObj,
  selectChangeIsRequired,
} from '../../../utils/breUtils';

const RuleEngine = (props) => {
  const { id, name, editable, hostType } = props.location.query;
  const dispatch = useDispatch();
  const [addVisble, setAddVisble] = useState(false);
  const [parents, setParents] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [form] = Form.useForm();
  const [cascaderData, setCascaderData] = useState({});
  const [addOptions, setAddOptions] = useState([]);
  const [showConform, setShowConform] = useState(false);
  const [filedValueChange, setFiledValueChange] = useState(false);

  // 发起请求
  const fetchData = useCallback(() => {
    dispatch({
      type: 'condition/getOutputList',
      payload: {
        values: {
          ruleOutputId: id,
        },
      },
    });
    dispatch({
      type: 'condition/getRuleList',
      payload: {
        values: {
          hostId: id,
          hostType: hostType || 'RULE_OUTPUT_RESULT',
        },
      },
      callback: (res) => {
        // console.log('res::', res);
        // form.resetFields(); //再次展开Form的列表首先清空
      },
    });
  }, [dispatch, form, id]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['condition/getRuleList'];
  const editTabel = (val) => {
    setParents(val);
    setAddVisble(true);
  };
  const handleCancel = () => {
    // setAddVisble(false);// 清除数据
    form.resetFields();
    fetchData();
  };
  const handleCancelOutput = () => {
    setAddVisble(false); // 清除数据
  };
  //获取rule原来的数据
  const data = useSelector((state) => state.condition.getRuleList);
  const {
    regularExpressions = [],
    relationNo,
    conditionMode,
    combineRelations = [],
  } = (data || {}).data || {};
  const [isSing, setIsSing] = useState(true);
  useEffect(() => {
    setIsSing(conditionMode === 'SINGLE' || false);
  }, [conditionMode]); //对当前是否单多条件进行判断，不放统一effect是因为要拿到mode,const不会声明提升
  const ruleList = isSing ? regularExpressions : combineRelations;

  const backHistory = () => {
    if (filedValueChange) {
      const formVal = form.getFieldsValue();
      let item = formVal;
      let hasNew = false;
      for (const key in item) {
        if (item[key]) {
          hasNew = true;
        }
      }
      if (hasNew) {
        setShowConform(true);
      } else {
        history.go(-1);
      }
    } else {
      history.go(-1);
    }
  };

  const cancelGoBack = () => {
    setShowConform(false);
  };
  const goBack = () => {
    setShowConform(false);
    history.go(-1);
  };

  const onValuesChange = () => {
    setFiledValueChange(true);
  };

  const onFinish = () => {
    setFiledValueChange(false);
    setSaveLoading(true);
    const oldData = JSON.parse(JSON.stringify(ruleList));
    const formVal = form.getFieldsValue();
    if (selectChangeIsRequired(formVal)) {
      setSaveLoading(false);
      message.warning('请填写完整');
      return;
    }

    const newdata = isSing
      ? handleFormData(oldData, formVal)
      : handleMultipleFormData(oldData, formVal);
    let newFormVal = formVal;
    for (const key in formVal) {
      if (!key.includes('null')) {
        delete newFormVal[key];
      }
    }
    //对数据进行判空
    let isRequire = false;
    newdata.map((item) => {
      if (isSing) {
        if (
          item['conditionType'] === 'FIELD' ||
          item['conditionType'] === 'COMBINE'
        ) {
          item['condition'] =
            item['condition'] instanceof Array
              ? item['condition'][1]
              : item['condition'];
        }

        if (item['valueType'] === 'VARIABLE') {
          item['value'] = item['value'] && item['value'][1];
        }
      } else {
        if (
          item['firstCondition']['conditionType'] === 'FIELD' ||
          item['firstCondition']['conditionType'] === 'COMBINE'
        ) {
          item['firstCondition']['condition'] =
            item['firstCondition']['condition'] instanceof Array
              ? item['firstCondition']['condition'][1]
              : item['firstCondition']['condition'];
        }
        if (
          item['secondCondition']['conditionType'] === 'FIELD' ||
          item['secondCondition']['conditionType'] === 'COMBINE'
        ) {
          item['secondCondition']['condition'] =
            item['secondCondition']['condition'] instanceof Array
              ? item['secondCondition']['condition'][1]
              : item['secondCondition']['condition'];
        }
        if (item['firstCondition']['valueType'] === 'VARIABLE') {
          item['firstCondition']['value'] =
            item['firstCondition']['value'] &&
            item['firstCondition']['value'][1];
        }
        if (item['secondCondition']['valueType'] === 'VARIABLE') {
          item['secondCondition']['value'] =
            item['secondCondition']['value'] &&
            item['secondCondition']['value'][1];
        }
      }
      // 暂时注释掉校验代码, 校验逻辑过于复杂, 后续逻辑确认后须放开
      if (isSing && item.id === null) {
        isRequire = hasUndefInObj(newFormVal, undefined);
      } else if (!isSing && !item.relationId) {
        isRequire = hasUndefInObj(newFormVal, undefined);
      }
      // // 对输入又清空的数据进行判""
      if (isRequire) {
        isRequire = true;
      } else {
        isRequire = hasUndefInObj(formVal, '');
      }
    });
    if (isRequire) {
      setSaveLoading(false);
      message.warning('请填写完整');
      return;
    }
    //保存接口
    if (isSing) {
      dispatch({
        type: 'condition/saveRuleList',
        payload: {
          values: {
            hostId: id,
            conditionMode: 'SINGLE',
            hostType: hostType || 'RULE_OUTPUT_RESULT',
            relationNo: relationNo ? relationNo : 1, //单条件初始1
            regularExpressions: newdata,
          },
        },
        callback: (d) => {
          setSaveLoading(false);
          const { id: b } = d || {};

          if (!b) {
            message.error('保存失败');
            // message.warn('请填写完整');
          } else {
            message.success('保存成功');
            // form.resetFields(); //再次展开Form的列表首先清空
            fetchData();
          }
        },
      });
    } else {
      dispatch({
        type: 'condition/saveMultipleRuleList',
        payload: {
          values: {
            hostId: id,
            conditionMode: 'MULTIPLE',
            hostType: hostType || 'RULE_OUTPUT_RESULT',
            // relationNo: relationNo ? relationNo : undefined,
            combineRelationRequests: newdata,
          },
        },
        callback: (res) => {
          setSaveLoading(false);
          const { code, message: msg } = res || {};
          if (code) {
            message.error(msg);
            // message.warn('请填写完整');
            return;
          }
          message.success('保存成功');
          // form.resetFields(); //再次展开Form的列表首先清空
          fetchData();
        },
      });
    }
  };
  //点击切换条件模式
  const hanleChangeRule = () => {
    setIsSing(!isSing);
  };

  // 获取级联下拉数据
  const fetchPackageData = useCallback(() => {
    dispatch({
      type: 'bre/getAllPackages',
      payload: {},
      callback: (res) => {
        let result = [];
        let cascaderDataUnuse = {};
        res &&
          res.length > 0 &&
          res.forEach((item) => {
            let child = [];
            item.fields &&
              item.fields.forEach((item2) => {
                child.push({
                  value: item2.id,
                  label: item2.fieldName,
                });
                cascaderDataUnuse[item2.id] = [item.fieldPackageId, item2.id];
              });
            result.push({
              value: item.fieldPackageId,
              label: item.fieldPackageName,
              children: child,
            });
          });
        setCascaderData(cascaderDataUnuse);
        setAddOptions(result);
      },
    });
  }, [dispatch]);
  // 发起请求
  useEffect(() => {
    fetchPackageData();
  }, [fetchPackageData]);

  return (
    <div className="re">
      <div className="contain">
        <Loading loading={loading || saveLoading} delay={10}>
          {/* <Loading loading={loading} delay={10}> */}
          <Form form={form} name="rule" onValuesChange={onValuesChange}>
            <BtnGroup
              {...props}
              id={id}
              name={name}
              handleSave={onFinish}
              backHistory={backHistory}
              conditionMode={conditionMode}
              hanleChangeRule={hanleChangeRule}
              handleCancel={handleCancel}
              isSing={isSing}
              editable={editable}
            />
            <Divider />
            <RuleTabel
              name={name}
              isSing={isSing}
              form={form}
              editable={editable}
              fetchData={fetchData}
            />
          </Form>

          <div className="output_tabel">
            <OutputTabel
              editTabel={editTabel}
              fetchData={fetchData}
              editable={editable}
            />
          </div>
          <ModalML
            title=""
            visible={addVisble}
            handleCancel={handleCancelOutput}
          >
            <AddRule
              handleCancel={handleCancelOutput}
              fetchData={fetchData}
              parents={parents}
              id={id}
              cascaderData={cascaderData}
              addOptions={addOptions}
            />
          </ModalML>

          <ModalConfirmML
            title="有尚未保存的更改，是否确认返回?"
            handleOk={goBack}
            handleCancel={cancelGoBack}
            visible={showConform}
          />
        </Loading>
      </div>
    </div>
  );
};

export default RuleEngine;
